module.exports = __webpack_public_path__ + "static/media/argoscholar_logo_dark.4d2f6cdc.svg";